import axios from "axios";
import moment from 'moment-jalaali'
import {bus} from "@/main";
import i18n from "@/i18n";

var closeBalance = {
    // const    selected_year= "2023";
    // const start_date= "12";
    items_terial_balance: [],
    data_moeins: [],
    current_level: 0,
    doc_date: '',
    curent_year_id: 0,
    // data() {
    //     return {
    //         selected_year: "2023",
    //         start_date: "12",
    //         items_terial_balance: [],
    //         data_moeins: [],
    //         current_level: 0,
    //     }
    // },
    // methods: {
    get_lists_moeins(doc_date,curent_year_id) {
        var self = this;
        const formData = new FormData();
        var url = "GetAllAccountTafsiliList";
self.doc_date = doc_date
self.curent_year_id = curent_year_id
        axios.post(url, formData, {}).then(function (response) {

                var content_data = response.data;

                if (content_data.statusCode == 0) {

                    self.data_moeins = response.data.data.map((item, row_id) => {
                        return {...item, row_id}
                    })


                    self.get_lists()
                    // get_lists()
                } else {
                    // $root.modal_component.show_danger_modal($t('dialogs.error'), content_data.message);
                }
            }
        )
            .catch(function (error) {
                console.log(error);
            });

    },
    get_lists() {
        var self = this;

        const formData = new FormData();


        formData.append('Id', 4);
        // var last_day2 = new Date(date2)
        // var last_day = new Date(last_day2.getFullYear(), last_day2.getMonth() + 1, 0)

        formData.append('FromDate', moment(self.get_max_doc_date()).locale('en').format('YYYY-MM-DD'));
        formData.append('ToDate', moment(self.get_max_doc_date()).locale('en').format('YYYY-MM-DD'));
        formData.append('YearDate', this.curent_year_id);
        var url = 'GetAllPersonAccountsMoein';
        axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
                self.items_terial_balance = content_data.data.personAccountItems.map((item, row_id) => {
                    return {...item, row_id}
                });
                self.items_terial_balance.forEach(function (val) {
                    if (val.natureId == 2) {
                        val.accBalanceFinal = (val.reminingBefore - parseFloat(val.amountNegetive)) + parseFloat(val.amount);
                    } else {
                        val.accBalanceFinal = (val.reminingBefore + parseFloat(val.amount)) - parseFloat(val.amountNegetive);
                    }
                })
                if (self.current_level == 0) {

                    var code6 = self.items_terial_balance.filter(x => x.personCode.startsWith("6"));
                    var destination = self.data_moeins.filter(x => x.tafsiliCode == "52111")[0]
                    self.insert_doc(6, code6, destination)

                } else if (self.current_level == 6) {
                    var code7 = self.items_terial_balance.filter(x => x.personCode.startsWith("7") || x.personCode.startsWith("8"));
                    var destination7 = self.data_moeins.filter(x => x.tafsiliCode == "52111")[0]
                    self.insert_doc(7, code7, destination7)

                } else if (self.current_level == 7) {
                    var code8 = self.items_terial_balance.filter(x => x.personCode == "52111" || x.personCode == "52211");
                    var destination8 = self.data_moeins.filter(x => x.tafsiliCode == "52011")[0]
                    self.insert_doc(9, code8, destination8)

                } else if (self.current_level == 9) {
                    // $router.push({path: "/dashboard/accounting/show-accounting-doc/" + res.data.data.id})
                    self.close_year();
                }


            } else {
                // $root.modal_component.show_danger_modal($t('dialogs.error'), content_data.message);

            }

        })
            .catch(function (error) {

                console.log(error);
            });

    },
    insert_doc(level, list, destination) {

        let self = this;
        const formData = new FormData();
        let url = "AddAccountDoc";

        var details = [];
        var diff = 0;
        for (var i = 0; i < list.length; i++) {
            var obj = {
                DocType: 10,
                DocName: 0,
                ReferenceId: 0,
                DocDate: self.doc_date,
                Summary: "closing balance",
                AccountId: self.data_moeins.filter(x=>x.tafsiliCode ==list[i].personCode)[0].accountId,
                TafsiliId: self.data_moeins.filter(x=>x.tafsiliCode ==list[i].personCode)[0].recId,
                TafsiliTitle: self.data_moeins.filter(x=>x.tafsiliCode ==list[i].personCode)[0].title,
                Debtor: 0,
                Creditor: 0,
            };
            diff = diff + list[i].accBalanceFinal;
            if (list[i].accBalanceFinal < 0) {
                obj.Debtor = Math.abs(list[i].accBalanceFinal)
            } else {
                obj.Creditor = Math.abs(list[i].accBalanceFinal)
            }
if(list[i].accBalanceFinal!=0){
    details.push(obj)

}
        }
        if (diff != 0) {
            var obj2 = {
                DocType: 10,
                DocName: 0,
                ReferenceId: 0,
                DocDate: self.doc_date,
                Summary: "closing balance",
                AccountId: destination.accountId,
                TafsiliId: destination.recId,
                TafsiliTitle: destination.title,
                Debtor: 0,
                Creditor: 0,
            };
            if (diff < 0) {
                obj2.Creditor = Math.abs(diff)
            } else {
                obj2.Debtor = Math.abs(diff)
            }
            details.push(obj2)
        }
// console.log("add doc",JSON.stringify(details))
//         return
        if(details.length==0){
            self.current_level = level;
            self.get_lists()
            return
        }
        formData.append('input', JSON.stringify(details));
        axios.post(url, formData, {}).then((res) => {

            // $root.modal_component.show_api_response_modals(res);

            if (res.data.statusCode == 0) {
                self.add_doc_to_final(res.data.data.id, level)

            }

        }).catch(function (error) {

            console.log(error);
        });

    },
    add_doc_to_final(id, level) {

        var self = this;

        const formData = new FormData();

        var url = "AddAccountDocFinal";

        formData.append("id", id);

        axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;


            if (content_data.statusCode == 0) {
                self.current_level = level;
                self.get_lists()
            } else {

            }


        })
            .catch(function (error) {

                console.log(error);
            });

    },
    get_min_doc_date() {
        return localStorage.getItem('fyear_min_date')
    },
    get_max_doc_date() {
        return localStorage.getItem('fyear_max_date')

    },
    get_today() {
        if (i18n.locale == "fa") {
            return moment().locale('fa').format('YYYY-MM-DD');
        } else {
            return moment().locale('en').format('YYYY-MM-DD');
        }
    },
    close_year() {

        var self = this;

        const formData = new FormData();

        var url = "CloseYear";

        formData.append("id", this.curent_year_id);

        axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;


            if (content_data.statusCode == 0) {
                localStorage.setItem("year_closed",1)
                bus.$emit("update_add_docs", "");

            }


        })
            .catch(function (error) {

                console.log(error);
            });

    },


}
export default closeBalance
